module.exports = __webpack_public_path__ + "static/media/bottleshot_signature.3357be48.png";